module.exports = __webpack_public_path__ + "img/no2_en.cce4a550.jpg";